const { clientType } = require('./client');

const WalletFeatures = {
  DEFAULT: 'DEFAULT',
  APPROVAL_FLOW: 'APPROVAL_FLOW',
};

const WalletStatusList = [
  {
    id: 0,
    name: 'select_all',
    label: 'Select All',
    display: 'Select All',
    color: 'green',
    parent: [],
  },
  {
    id: 1,
    name: 'settled',
    label: 'Settled',
    display: 'Settled',
    color: 'green',
    parent: [{
      ids: [6],
      features: WalletFeatures.APPROVAL_FLOW,
      actionAllowedParty: clientType.SHIPPER,
    }, {
      ids: [2],
      features: WalletFeatures.DEFAULT,
      actionAllowedParty: clientType.SHIPPER,
    }],
  },
  {
    id: 2,
    name: 'generated',
    label: 'Generated',
    display: 'Generated',
    color: 'purple',
    parent: [], // Root status of invoice flow
  },
  {
    id: 3,
    name: 'ins_claim',
    label: 'Insurance claim',
    display: 'Ins. Claim',
    color: 'purple',
    parent: [],
  },
  {
    id: 4,
    name: 'disputed',
    label: 'Disputed',
    display: 'Disputed',
    color: 'pink',
    parent: [{
      ids: [2],
      features: WalletFeatures.APPROVAL_FLOW,
      actionAllowedParty: clientType.TRANSPORTER,
    }],
  },
  {
    id: 5,
    name: 'under_review',
    label: 'Under Review',
    display: 'Under Review',
    color: 'yellow',
    parent: [{
      ids: [4],
      features: WalletFeatures.APPROVAL_FLOW,
      actionAllowedParty: clientType.SHIPPER,
    }],
  },
  {
    id: 6,
    name: 'accepted',
    label: 'Accepted',
    display: 'Accepted',
    color: 'blue',
    parent: [{
      ids: [2, 4, 5, 6],
      features: WalletFeatures.APPROVAL_FLOW,
      actionAllowedParty: clientType.SHIPPER,
    }],
  },
  {
    id: 7,
    name: 'reconciliation_pending',
    label: 'Reconciliation Pending',
    display: 'Reconciliation Pending',
    color: 'yellow',
    parent: [],
  },
];

// do not change the order members in this WalletReason object
const WalletReason = {
  SHORTAGE: 1,
  DAMAGE: 2,
  CARTON_DAMAGE: 3,
  TRANSIT_DELAY: 4,
  REJECTION_PENALTY: 5,
  SLA_BREACH: 6,
  LEAKAGE: 7,
  SLA_BREACH_RE_ASSIGNED: 8,
  RECONCILE: 9,
  OPEN_DEBIT: 10,
  RFQ_DEBIT: 11,
  CONTRACT_REINDENT: 12,
  DEBIT_ADJUSTMENT: 13,
  ACCEPTANCE_SLA_BREACH_RE_ASSIGNED: 14,
  DEDUCTIBLES: 15,
  FIXED_DEBIT: 16,
  TEMPERATURE_COMPLIANCE_PENALTY: 17,
};

const WalletHeader = {
  TRANSIT_DELAY: 'Transit days',
  SHORTAGE: 'Material Code',
  DAMAGE: 'Material Code',
  CARTON_DAMAGE: 'Material Code',
  REJECTION_PENALTY: 'Transporter Rejection',
  ACCEPTANCE_SLA_BREACH_RE_ASSIGNED: 'Acceptance SLA Breach',
  SLA_BREACH: 'SLA Breach',
  SLA_BREACH_RE_ASSIGNED: 'SLA Breach - Reassigned',
  RFQ_DEBIT: 'RFQ Debit',
  OPEN_DEBIT: 'Open Debit',
  CONTRACT_REINDENT: 'Contract Reindent',
  RECONCILE: 'Reconciled',
  DEDUCTIBLES: 'Deductible',
  FIXED_DEBIT: 'Fixed Debit',
  TEMPERATURE_COMPLIANCE_PENALTY: 'Temperature Compliance Penalty',
};

const WalletReasonMap = {
  1: 'SHORTAGE',
  2: 'DAMAGE',
  3: 'CARTON_DAMAGE',
  4: 'TRANSIT_DELAY',
  5: 'REJECTION_PENALTY',
  6: 'SLA_BREACH',
  7: 'LEAKAGE',
  8: 'SLA_BREACH_RE_ASSIGNED',
  9: 'RECONCILE',
  10: 'OPEN_DEBIT',
  11: 'RFQ_DEBIT',
  12: 'CONTRACT_REINDENT',
  13: 'DEBIT_ADJUSTMENT',
  14: 'ACCEPTANCE_SLA_BREACH_RE_ASSIGNED',
  15: 'DEDUCTIBLES',
  16: 'FIXED_DEBIT',
  17: 'TEMPERATURE_COMPLIANCE_PENALTY',
};

const transporterDebitChargesMap = {
  1: 'shortage_charge',
  2: 'damage_charge',
  3: 'carton_damage_charge',
  4: 'transit_charge',
  5: 'rejection_penalty',
  6: 'arrival_charge',
  7: 'leakage',
  8: 'sla_breach_re_assigned',
  10: 'open_debit',
  11: 'rfq_debit',
  12: 'contract_reindent',
  13: 'debit_adjustment',
  14: 'acceptance_sla_breach',
  15: 'deductibles',
};

const WalletReasonList = [{
  id: WalletReason.SHORTAGE,
  name: 'Shortage',
  label: 'shortage',
},
{
  id: WalletReason.DAMAGE,
  name: 'Damage',
  label: 'damage',
},
{
  id: WalletReason.CARTON_DAMAGE,
  name: 'Carton Damage',
  label: 'carton_damage',
},
{
  id: WalletReason.TRANSIT_DELAY,
  name: 'Transit Delay',
  label: 'transit_delay',
},
{
  id: WalletReason.REJECTION_PENALTY,
  name: 'Transporter Rejection',
  label: 'rejection_penalty',
},
{
  id: WalletReason.SLA_BREACH,
  name: 'SLA Breach',
  label: 'sla_breach',
},
{
  id: WalletReason.RECONCILE,
  name: 'Reconciled',
  label: 'reconcile',
},
{
  id: WalletReason.SLA_BREACH_RE_ASSIGNED,
  name: 'SLA Breach - Reassigned',
  label: 'sla_breach_re_assigned',
},
{
  id: WalletReason.OPEN_DEBIT,
  name: 'Open Debit',
  label: 'open_debit',
},
{
  id: WalletReason.RFQ_DEBIT,
  name: 'RFQ Debit',
  label: 'rfq_debit',
},
{
  id: WalletReason.CONTRACT_REINDENT,
  name: 'Contract Reindent',
  label: 'contract_reindent',
},
{
  id: WalletReason.DEBIT_ADJUSTMENT,
  name: 'Debit Adjustment',
  label: 'debit_adjustment',
},
{
  id: WalletReason.ACCEPTANCE_SLA_BREACH_RE_ASSIGNED,
  name: 'ACCEPTANCE SLA Breach',
  label: 'acceptance_sla_breach_re_assigned',
},
{
  id: WalletReason.DEDUCTIBLES,
  name: 'Deductibles',
  label: 'deductibles',
},
{
  id: WalletReason.FIXED_DEBIT,
  name: 'Fixed Debit',
  label: 'fixed_debit',
},
  {
    id: WalletReason.TEMPERATURE_COMPLIANCE_PENALTY,
    name: 'Temperature Compliance Penalty',
    label: 'temperature_compliance_penalty',
  },
];

const WalletApprovalAt = {
  SOURCE: 'source',
  DESTINATION: 'destination',
};

const WalletReversalType = {
  DAILY_RECONCILIATION: 1,
  MONTHLY_RECONCILIATION: 2,
  SURGE_INDENT: 3,
  WALLET_ENTRY_AUTO_ACCEPTED_SINCE_OVERALL_PR_IS_GREATER_THAN_THRESHOLD: 4,
  WALLET_ENTRY_AUTO_ACCEPTED_SINCE_LANE_LEVEL_PR_IS_GREATER_THAN_THRESHOLD: 5,
};

const WalletStatus = WalletStatusList.reduce((acc, status) => Object.assign(acc, {
  [status.name.toUpperCase()]: status.id,
}), {});

const ReconcilePrefix = 'RECONCILE-';

const decoupledChargesMap = {
  DAMAGE: 'damage',
  CARTON_DAMAGE: 'carton_damage',
  SHORTAGE: 'shortage',
  LEAKAGE_CHARGE: 'leakage_charge',
  SLA_DELAY: 'sla_delay',
  TRANSIT_DELAY: 'transit_delay',
};

module.exports = {
  WalletStatus,
  WalletStatusList,
  WalletReason,
  WalletReasonList,
  WalletReasonMap,
  transporterDebitChargesMap,
  ReconcilePrefix,
  WalletFeatures,
  WalletApprovalAt,
  WalletReversalType,
  decoupledChargesMap,
  WalletHeader,
};
